import React from 'react'
import styleClasses from '../components/common/common.module.scss'
import EventsListByBuilding from '../components/events/EventsListByBuilding'
import Container from '@material-ui/core/Container'

export default function EventsPage() {
  return (
    <main className={styleClasses.content}>
      <Container maxWidth="lg" className={styleClasses.container}>
        <EventsListByBuilding></EventsListByBuilding>
      </Container>
    </main>
  )
}
